export default Object.freeze({

    PRODUCT_LINE_OO2: {
        name: "Outdoor Ages 2 - 12 Years",
        id: 14
    },
    PRODUCT_LINE_OU2: {
        name: "Outdoor Under 2 Years",
        id: 21
    },
    PRODUCT_LINE_IO2: {
        name: "Indoor 2 Years & Over",
        id: 13
    },
    PRODUCT_LINE_IU2: {
        name: "Indoor Under 2 Years",
        id: 17
    },

    AGE_RANGE_DEFAULT: 'default',
    AGE_RANGE_UNDER_TWO: '6-23 months',
    AGE_RANGE_TWO_TO_FIVE: '2-5',
    AGE_RANGE_FIVE_TO_TWELVE: '5-12',
    AGE_RANGE_TWO_TO_TWELVE: '2-12',

    SORT_RECOMMENDED: 'marketing-picks',
    SORT_PRICE_LOW_TO_HIGH: 'price,asc',
    SORT_PRICE_HIGH_TO_LOW: 'price,desc',
    SORT_ALPHABETICAL_ASC: 'alphabetical,asc',
    SORT_ALPHABETICAL_DESC: 'alphabetical,desc',
})
